/* 🤖 this file was generated by svg-to-ts */
export const matIconLegendToggle: {
  name: 'legend-toggle';
  data: string;
} = {
  name: 'legend-toggle',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 15H4v-2h16v2zm0 2H4v2h16v-2zm-5-6 5-3.55V5l-5 3.55L10 5 4 8.66V11l5.92-3.61L15 11z"/></svg>`
};
